import { CACHE_TTL_1_HOUR } from "@/config/cacheLifetime.config";
import { CacheTag } from "@/enums/cacheTags";

const CACHE_TTL_2_MINUTES = 120;
export const CACHE_TTL = {
  cacheTTL: {
    // Search
    [CacheTag.SEARCH_RECOMMENDED_CITY]: CACHE_TTL_1_HOUR,
    [CacheTag.SEARCH_REGION]: CACHE_TTL_1_HOUR,
    [CacheTag.SEARCH_PROPERTY_TYPE]: CACHE_TTL_1_HOUR,
    [CacheTag.SEARCH_CHECKBOXES]: CACHE_TTL_1_HOUR,
    [CacheTag.SEARCH_PROPERTY_OPTIONS]: CACHE_TTL_1_HOUR,

    // Collections / lists
    [CacheTag.PROPERTY_COLLECTION]: CACHE_TTL_1_HOUR,

    // SEO
    [CacheTag.SEO_METADATA]: CACHE_TTL_1_HOUR,
    [CacheTag.SEO_TEMPLATE]: CACHE_TTL_1_HOUR,
    [CacheTag.SEO_TEMPLATES_BATCH]: CACHE_TTL_1_HOUR,
    [CacheTag.SEO_VARIABLES]: CACHE_TTL_1_HOUR,
  },
};
